const actions = (state, payload) => (
    {
        setUser: () => {
            return { ...state, user: payload }
        },
        setFlash: () => {
            return { ...state, flash: payload }
        },
        setActivity: () => {
            return { ...state, activity: payload }
        },
        setSocket: () => {
            return { ...state, socket: payload }
        },
        
    }
)

export default actions;